import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';

import {
  getServices,
  deleteOtherServicesInfo,
  deletePromotionParticularsInfo,
  deleteServicesHistoryInfo,
  updateOtherServicesInfo,
  updatePromotionParticularsInfo,
  updateServiceHistoryInfo,
} from '@api/services';

import {
  ServicesActions,
  deleteOtherServicesInfoFailed,
  deleteOtherServicesInfoSuccess,
  deletePromotionParticularsInfoFailed,
  deletePromotionParticularsInfoSuccess,
  deleteServicesHistoryInfoFailed,
  deleteServicesHistoryInfoSuccess,
  getServicesFailed,
  getServicesSuccess,
  updateOtherServicesInfoFailed,
  updateOtherServicesInfoSuccess,
  updatePromotionParticularsInfoFailed,
  updatePromotionParticularsInfoSuccess,
  updateServicesHistoryFailed,
  updateServicesHistorySuccess,
} from '@actions/HRM/employee/services-actions';
import {
  GET_SERVICES,
  UPDATE_SERVICE_HISTORY_INFO,
  UPDATE_PROMOTION_PARTICULARS_INFO,
  UPDATE_OTHER_SERVICES_INFO,
  DELETE_SERVICE_HISTORY_INFO,
  DELETE_PROMOTION_PARTICULARS_INFO,
  DELETE_OTHER_SERVICES_INFO,
} from '@actions/HRM/employee/types';

import { isRequestCancelled } from '@helpers/routing';
import { StoreType } from '@reducers/types';

export const servicesMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: ServicesActions) => {
      const nextAction = next(action);
      switch (action.type) {
        case GET_SERVICES.GET_SERVICES_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await getServices(payload);

            dispatch(getServicesSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getServicesFailed());
            }
          }
          break;
        }

        case UPDATE_SERVICE_HISTORY_INFO.UPDATE_SERVICE_HISTORY_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateServiceHistoryInfo(payload);

            dispatch(updateServicesHistorySuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateServicesHistoryFailed());
            }
          }

          break;
        }

        case UPDATE_PROMOTION_PARTICULARS_INFO.UPDATE_PROMOTION_PARTICULARS_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updatePromotionParticularsInfo(payload);

            dispatch(updatePromotionParticularsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updatePromotionParticularsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_OTHER_SERVICES_INFO.UPDATE_OTHER_SERVICES_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateOtherServicesInfo(payload);

            dispatch(updateOtherServicesInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateOtherServicesInfoFailed());
            }
          }

          break;
        }

        case DELETE_SERVICE_HISTORY_INFO.DELETE_SERVICE_HISTORY_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteServicesHistoryInfo(payload);

            dispatch(deleteServicesHistoryInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteServicesHistoryInfoFailed());
            }
          }

          break;
        }

        case DELETE_PROMOTION_PARTICULARS_INFO.DELETE_PROMOTION_PARTICULARS_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deletePromotionParticularsInfo(payload);
            dispatch(deletePromotionParticularsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deletePromotionParticularsInfoFailed());
            }
          }

          break;
        }

        case DELETE_OTHER_SERVICES_INFO.DELETE_OTHER_SERVICES_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteOtherServicesInfo(payload);

            dispatch(deleteOtherServicesInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteOtherServicesInfoFailed());
            }
          }

          break;
        }
      }
      return nextAction;
    };
  };
};
